import React from "react";
import { Text } from "@sede-enterprise/shell-ds-react-framework";

interface LoaderProps {
  message?: string;
  size?: "small" | "medium" | "large";
}

const Loader: React.FC<LoaderProps> = ({
  message = "Loading...",
  size = "medium",
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      width: "20px",
      height: "20px",
      borderWidth: "2px",
    },
    medium: {
      width: "32px",
      height: "32px",
      borderWidth: "3px",
    },
    large: {
      width: "48px",
      height: "48px",
      borderWidth: "4px",
    },
  };

  const currentSize = sizeConfig[size];

  return (
    <div
      data-testid="loader"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        gap: "16px",
      }}
    >
      {/* Spinner */}
      <div
        style={{
          width: currentSize.width,
          height: currentSize.height,
          border: `${currentSize.borderWidth} solid var(--shell-color-border-subtle, #e2e8f0)`,
          borderTop: `${currentSize.borderWidth} solid var(--shell-color-primary, #007fa2)`,
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />

      {/* Loading message */}
      {message && (
        <Text
          size="medium"
          style={{
            color: "var(--shell-color-text-secondary, #64748b)",
            textAlign: "center",
          }}
        >
          {message}
        </Text>
      )}

      {/* CSS Animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
